import React from 'react'

const Menu = ({ color = '#DC7B19', size = '5' }) => {
  return (
    <svg
      className={`h-${size} w-${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 17.625V16.125H20.75V17.625H3.25ZM3.25 12.75V11.25H20.75V12.75H3.25ZM3.25 7.875V6.375H20.75V7.875H3.25Z"
        fill={color}
      />
    </svg>
  )
}

export default Menu
